module.exports = __webpack_public_path__ + "img/ios.a002db13.png";